<template>
<div class="page page_video_detail">
	<!-- 111111 -->
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false" >
    <div class="video_chapters">
		<div v-for="(item,key) in dataList" :key="key" class="video_chapter clearfix" @click="goPlayVideo(item)">
			<!-- item.videochapter.is_charge == 1 && detail.is_buy == 1 -->
			<div class="video_status f-l" v-if="item.videochapter.is_charge == 1 && item.videochapter.is_buy == 1">
				<span class="sk" v-if="item.videochapter.times && item.videochapter.times != 0">试看</span>
				<img :src="publicPath + 'statics/images/lock.png'" class="locked" alt="" v-if="!item.videochapter.times">
			</div>
			<div class="video_tu f-r">
				<img :src="imageUrl+item.videochapter.thumb" />
			</div>
			<div class="video_content">
				<h3 class="video_title">{{ item.videochapter.title }}</h3>
				<p class="video_desc">{{ item.videochapter.describe }}</p>
			</div>
		</div>
	</div>
	</van-list>
</div>
</template>

<script>
import router from '../../../../.././router';
import {
    LOGOUT,
    LOGIN
} from '../../../../.././vuex/mutation_types';
import PageSearch from '../../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            token: '',
			publicPath: process.env.BASE_URL,
			pages: {
				page: 1,
				size: 10
			},
			loading: true,
			finished: false,
			goNext: false,
			dataList: []
        };
    },
    created() {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '观看记录',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
                var memberParams = {
                    data: {
                        'notCallLogin': 1,
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
							this.getData();
                        } else {
                            this.token = "";
                        }
                        
                    }
                );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
				// alert(JSON.stringify(data));
				this.pages.page = 1
				this.getData();
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token;
			this.getData();
        }
    },
	activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.pages.page = 1
			this.getData();
		}
	},
    methods: {
        // 获取观看记录
        getData() {
			if (!this.token) {
				return
			}
			var that = this
			var params = {
				token: that.token,
				page: that.pages.page,
				size: 10
			}
			that.$api.living.myVideoLog(params).then(res=>{
				if(res.code == 200){
					// 返回的数据不全,待改好再写
					var list = res.result
					if(list.length != 0){
						that.dataList = that.dataList.concat(list)
						that.pages.page++
						that.loading = false
					}else{
						that.finished = true
					}
				}else{
					that.finished = true
				}
			})
        },
        // 去播放视频
        goPlayVideo(item) {
			var that = this
			this.goNext = true
			// 判断是否需要购买 is_charge 1付费,0免费; is_buy 0已购买过,1未购买
			that.$router.push({
				path: '/video/play',
				query: {
					id: item.videochapter.id,
					is_buy: item.videochapter.is_buy,
					is_charge: item.videochapter.is_charge
				}
			});
        }
    }
};
</script>

<style lang="postcss" scoped>
</style>
